/**
 * Created by katarinababic on 22.4.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useTrans } from '../../Store/System/LocalizationStore';
import { WorkoutTemplateEntry } from '../../Model/Explore/WorkoutTemplateEntry';
import { ExploreEntryContainer, ExploreEntryContainerProps } from './ExploreEntryContainer';
import styled from '@emotion/styled';
import { useRootStore } from '../../Store/useRootStore';
import { CoachWorkout } from '../../Model/Coach/Program/Workout/CoachWorkout';
import { useState } from 'react';
import { ViewPhase } from '../../Model/WorkoutLog/ViewPhase';
import { ViewBlock } from '../../Model/WorkoutLog/ViewBlock';

const InnerContainer = styled.div`
  position: relative;
  height: 100%;
`;

const PlayOverlayContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const PlayIcon = styled.img`
  position: absolute;
  width: 50px;
`;

const ContentOverlayContainer = styled.div`
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: flex-end;
`;

const Duration = styled.div`
  background: rgba(0, 0, 0, 0.8);
  border-radius: 16px;
  padding: 3.70012px 11.1003px 4.62514px;
  font-size: 14px;
`;

type SectionData = { phase: ViewPhase; data: ViewBlock[] };

export type ExploreEntryRendererWorkoutTemplateProps = ExploreEntryContainerProps & {
  entry: WorkoutTemplateEntry;
};

export const ExploreEntryRendererWorkoutTemplate: React.FC<ExploreEntryRendererWorkoutTemplateProps> = observer(
  ({ entry, ...moreProps }) => {
    const { t } = useTrans();
    const { workoutViewStore } = useRootStore();

    const [loading, setLoading] = React.useState<boolean>(false);
    const [generatedWorkout, setGeneratedWorkout] = React.useState<CoachWorkout | undefined>(undefined);
    const [sections, setSections] = useState<SectionData[]>([]);
    const showErrorMsg = !loading && !generatedWorkout;

    const { durationInMinutes } = entry;

    return (
      <ExploreEntryContainer entry={entry} {...moreProps}>
        <InnerContainer>
          <PlayOverlayContainer>
            <PlayIcon src={require('../../Assets/Images/play_icon.png')} />
          </PlayOverlayContainer>
          <ContentOverlayContainer>
            {durationInMinutes ? (
              <Duration>
                {t('global.timeMinShort', { defaultValue: '{{minutes}} mins', minutes: durationInMinutes })}
              </Duration>
            ) : (
              <div />
            )}
          </ContentOverlayContainer>
        </InnerContainer>
      </ExploreEntryContainer>
    );
  },
);
